
    <div class="row">
      <input id="input-file" #inputFileUpload type="file" style="display:none" (change)="upload($event)" accept="image/*"/>
      <modal class="logo" #modal #modalEl (onClose)="closeModalEvent()" [backdrop]="true">
        <modal-header>
          <h3 class="no-margin">{{ limitExceeded ? 'Atenção' : 'Ajuste da imagem' }}</h3>
        </modal-header>
        <modal-content>

          <div class="row">
            <div class="col-xs-12 col-md-12">
              <div class="crop-container">
                <img #imgCrop class="crop-image" src=""/>
              </div>

              <div class="col-xs-12 col-md-12 cropper" *ngIf="!limitExceeded">
                <div class="btn-zoom">
                  <button type="button" class="btn btn-logo-tools" (click)="resizeWidth(200)">
                    <img src="./assets/shared/img/square.svg"></button>
                  <button type="button" class="btn btn-logo-tools" (click)="resizeWidth(400)">
                    <img src="./assets/shared/img/rectangular.svg"></button>
                  <button type="button" class="btn btn-logo-tools" [disabled]="!hasImage" (click)="zoom(0.1)">
                    <img src="./assets/shared/img/zoom-in.svg"></button>
                  <button type="button" class="btn btn-logo-tools" [disabled]="!hasImage" (click)="zoom(-0.1)">
                    <img src="./assets/shared/img/zoom-out.svg"></button>
                </div>
              </div>

            </div>

            <div class="col-xs-12 col-md-12" *ngIf="limitExceeded">
              <p>A imagem excede o limite de upload de 1MB. Por favor escolha outra imagem ou reduza o tamanho desta imagem.</p>
            </div>
          </div>

        </modal-content>
        <modal-footer>
          <button class="btn btn-primary" [disabled]="!hasImage" *ngIf="!limitExceeded" (click)="close()">OK</button>
          <button class="btn btn-primary" *ngIf="limitExceeded" (click)="closeModalEvent()">Voltar</button>
        </modal-footer>
      </modal>
    </div>
  